import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mt-icon-edit',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icon-edit.ui-component.html',
  styleUrl: './icon-edit.ui-component.scss',
})
export class IconEditUiComponent {}
